import Quote from "@/icons/ui/quote.svg";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import Overline from "~/componentsDS/Typography/Overline";
import { Tooltip } from "~/components/ui/Tooltip";
import { cn } from "~/lib/utils";
import type { GtmEvent } from "~/lib/gtm/getGtmEventData";

type Props = {
    className?: string;
    eventData?: GtmEvent;
    variant?: "dark" | "primary";
};

const tooltipContent = (
    <div className="font-[Helvetica] text-[16px] leading-[1.44]">
        <p className="font-bold mb-1">FDA announcement</p>
        <p>The FDA’s decision reflects updated research confirming that hormone therapy are both safe and beneficial.</p>
    </div>
);

export const BlackBox = ({ className, eventData, variant = "dark" }: Props) => {
    return (
        <div className={cn("flex gap-2", className)}>
            <Quote className="w-6 h-6 text-primary500 shrink-0" />

            <div className="flex flex-col items-start">
                <Paragraph size="lg" className="mb-2">Estrogen is one of the most effective longevity interventions for women.</Paragraph>
                <Overline size="sm" weight="500" className="mb-2 md:mb-1">FDA announcement, <span className="text-gray400 font-normal">November 2025</span></Overline>

                <Tooltip content={tooltipContent} position="top-left" eventData={eventData} variant={variant}>
                    <Overline size="sm" weight="500" className="text-primary300 underline">More info</Overline>
                </Tooltip>
            </div>
        </div>
    );
};

export default BlackBox;
